document.addEventListener("DOMContentLoaded", () => {
  let loading = false;
  let flkty;
  // Gift variant ids the auto-add path has already tried this page load.
  const autoAddTried = new Set();


  document.querySelector(".action_cart").addEventListener("click", () => {
    document.querySelector(".cart-drawer").classList.add("active");
  });

  if (!customElements.get("free-gift-progress")) {
    customElements.define(
      "free-gift-progress",
      class FreeGiftProgress extends HTMLElement {
        constructor() {
          super();

          this.progressSettings = JSON.parse(
            this.querySelector("#free-gift-tier-amount").innerHTML,
          );

          this.cartTotalPrice =
            this.progressSettings.cartTotalPrice +
            this.progressSettings.thresholdAmount;

          if (this.querySelector("#free-gift-multiple-bar")) {
            this.onUpdateMultipleBar();
          } else {
            this.onUpdateOneBar();
          }
        }

        progressSettings = {};
        cartTotalPrice = 0;

        onUpdateMultipleBar() {
          const rate = Number(window.Shopify.currency.rate);
          const currency = this.progressSettings.currency;

          let oneText = "";
          let oneWidth = "";
          let oneAmount = 0;
          if (
            this.cartTotalPrice <
            this.progressSettings.tierOneAmount * rate
          ) {
            oneAmount = this.progressSettings.tierOneAmount * rate;

            if (this.querySelector('[for="tier-one-currency"]'))
              this.querySelector('[for="tier-one-currency"]').innerHTML =
                currency + (oneAmount / 100).toFixed(2);

            oneText = this.progressSettings.tierOneText.replace(
              "$money",
              currency +
                (
                  (this.progressSettings.tierOneAmount * rate -
                    this.cartTotalPrice) /
                  100
                ).toFixed(2),
            );
            oneWidth =
              (this.cartTotalPrice /
                (this.progressSettings.tierOneAmount * rate)) *
              100;
          } else {
            oneText = this.progressSettings.tierOneFullfilText;
            oneWidth = 100;
          }
          if (this.querySelector("#tier-one-bar"))
            this.querySelector("#tier-one-bar").style.width = `${oneWidth}%`;

          if (
            this.querySelector("#tier-one-fullfil-text") &&
            oneWidth === 100
          ) {
            this.querySelector("#tier-one-fullfil-text").innerHTML = oneText;
          } else if (this.querySelector("#tier-one-text")) {
            this.querySelector("#tier-one-text").innerHTML = oneText;
            const text = this.progressSettings.tierOneUnfullfilText.replace(
              "$money",
              currency + (oneAmount / 100).toFixed(2),
            );
            this.querySelector("#tier-one-fullfil-text").innerHTML = text;
          }

          let twoText = "";
          let twoWidth = "";
          if (
            this.cartTotalPrice <
            this.progressSettings.tierTwoAmount * rate
          ) {
            const twoAmount = this.progressSettings.tierTwoAmount * rate;

            if (this.querySelector('[for="tier-two-currency"]'))
              this.querySelector('[for="tier-two-currency"]').innerHTML =
                currency + (twoAmount / 100).toFixed(2);

            twoText = this.progressSettings.tierTwoText.replace(
              "$money",
              currency + ((twoAmount - this.cartTotalPrice) / 100).toFixed(2),
            );
            twoWidth =
              (this.cartTotalPrice /
                (this.progressSettings.tierTwoAmount * rate)) *
              100;
          } else {
            twoText = this.progressSettings.tierTwoFullfilText;
            twoWidth = 100;
          }

          if (this.querySelector("#tier-two-bar"))
            this.querySelector("#tier-two-bar").style.width = `${twoWidth}%`;

          if (
            this.querySelector("#tier-two-fullfil-text") &&
            twoWidth === 100
          ) {
            this.querySelector("#tier-two-fullfil-text").innerHTML = twoText;
          } else if (this.querySelector("#tier-two-text")) {
            this.querySelector("#tier-two-text").innerHTML = twoText;
            this.querySelector("#tier-two-fullfil-text").style.display = "none";
          }

          let threeText = "";
          let threeWidth = "";
          let threeAmount = 0;
          if (
            this.cartTotalPrice <
            this.progressSettings.tierThreeAmount * rate
          ) {
            threeAmount = this.progressSettings.tierThreeAmount * rate;

            if (this.querySelector('[for="tier-three-currency"]'))
              this.querySelector('[for="tier-three-currency"]').innerHTML =
                currency + (threeAmount / 100).toFixed(2);

            threeText = this.progressSettings.tierThreeText.replace(
              "$money",
              currency + ((threeAmount - this.cartTotalPrice) / 100).toFixed(2),
            );
            threeWidth =
              (this.cartTotalPrice /
                (this.progressSettings.tierThreeAmount * rate)) *
              100;
          } else {
            threeText = this.progressSettings.tierThreeFullfilText;
            threeWidth = 100;
          }
          if (this.querySelector("#tier-three-bar"))
            this.querySelector("#tier-three-bar").style.width =
              `${threeWidth}%`;
          if (
            this.querySelector("#tier-three-fullfil-text") &&
            threeWidth === 100
          ) {
            this.querySelector("#tier-three-fullfil-text").innerHTML =
              threeText;
          } else if (this.querySelector("#tier-three-text")) {
            this.querySelector("#tier-three-text").innerHTML = threeText;
            const text = this.progressSettings.tierThreeUnfullfilText.replace(
              "$money",
              currency + (threeAmount / 100).toFixed(2),
            );
            this.querySelector("#tier-three-fullfil-text").innerHTML = text;
          }

          let fourText = "";
          let fourWidth = "";
          let fourAmount = "";
          if (
            this.cartTotalPrice <
            this.progressSettings.tierFourAmount * rate
          ) {
            fourAmount = this.progressSettings.tierFourAmount * rate;

            if (this.querySelector('[for="tier-four-currency"]'))
              this.querySelector('[for="tier-four-currency"]').innerHTML =
                currency + (fourAmount / 100).toFixed(2);

            fourText = this.progressSettings.tierFourText.replace(
              "$money",
              currency + ((fourAmount - this.cartTotalPrice) / 100).toFixed(2),
            );
            fourWidth =
              (this.cartTotalPrice /
                (this.progressSettings.tierFourAmount * rate)) *
              100;
          } else {
            fourText = this.progressSettings.tierFourFullfilText;
            fourWidth = 100;
          }
          if (this.querySelector("#tier-four-bar"))
            this.querySelector("#tier-four-bar").style.width = `${fourWidth}%`;

          if (
            this.querySelector("#tier-four-fullfil-text") &&
            fourWidth === 100
          ) {
            this.querySelector("#tier-four-fullfil-text").innerHTML = fourText;
          } else if (this.querySelector("#tier-four-text")) {
            this.querySelector("#tier-four-text").innerHTML = fourText;
            const text = this.progressSettings.tierFourUnfullfilText.replace(
              "$money",
              currency + (fourAmount / 100).toFixed(2),
            );
            this.querySelector("#tier-four-fullfil-text").innerHTML = text;
          }
        }

        onUpdateOneBar() {
          let text = "";
          const rate = Number(window.Shopify.currency.rate);
          const currency = this.progressSettings.currency;
          let width =
            (this.cartTotalPrice /
              (this.progressSettings.tierThreeAmount * rate)) *
            100;

          if (
            this.cartTotalPrice <
            this.progressSettings.tierOneAmount * rate
          ) {
            text = this.progressSettings.tierOneText.replace(
              "$money",
              currency +
                (
                  (this.progressSettings.tierOneAmount * rate -
                    this.cartTotalPrice) /
                  100
                ).toFixed(2),
            );
          } else if (
            this.cartTotalPrice <
            this.progressSettings.tierTwoAmount * rate
          ) {
            this.querySelector("#one-bar-tier-one-title")?.classList.add(
              "fullfil",
            );
            text = this.progressSettings.tierTwoText.replace(
              "$money",
              currency +
                (
                  (this.progressSettings.tierTwoAmount * rate -
                    this.cartTotalPrice) /
                  100
                ).toFixed(2),
            );
          } else if (
            this.cartTotalPrice <
            this.progressSettings.tierThreeAmount * rate
          ) {
            this.querySelector("#one-bar-tier-one-title")?.classList.add(
              "fullfil",
            );
            this.querySelector("#one-bar-tier-two-title")?.classList.add(
              "fullfil",
            );
            text = this.progressSettings.tierThreeText.replace(
              "$money",
              currency +
                (
                  (this.progressSettings.tierThreeAmount * rate -
                    this.cartTotalPrice) /
                  100
                ).toFixed(2),
            );
          } else {
            text = this.progressSettings.tierThreeFullfilText;
            this.querySelector("#one-bar-tier-one-title")?.classList.add(
              "fullfil",
            );
            this.querySelector("#one-bar-tier-two-title")?.classList.add(
              "fullfil",
            );
            this.querySelector("#one-bar-tier-three-title")?.classList.add(
              "fullfil",
            );
            width = 100;
          }

          if (this.querySelector("#one-bar-text")) {
            this.querySelector("#one-bar-text").innerHTML = text;
            this.querySelector("#one-bar-progress").style.width = `${width}%`;
          }
        }
      },
    );
  }

  if (!customElements.get("free-gift-product")) {
    customElements.define(
      "free-gift-product",
      class FreeGiftProduct extends HTMLElement {
        constructor() {
          super();
          this.rate = Number(window.Shopify.currency.rate);

          this.cartItems = JSON.parse(
            this.querySelector("#cart-json").innerHTML,
          );

          this.cartTotalPrice =
            this.cartItems.total_price +
            Number(this.getAttribute("data-threshold-amount"));
          this.freeProductData = JSON.parse(
            this.querySelector("#free-product-variants").innerHTML,
          );
          this.freeProductAmount =
            Number(this.getAttribute("data-free-number")) * this.rate;

          if (this.cartTotalPrice >= this.freeProductAmount) {
            this.querySelector(".add-btn").classList.remove("disabled");
            this.querySelector(".add-btn").removeAttribute("aria-disabled");
          }

          const json = JSON.parse(
            this.querySelector("#free-product-json").innerHTML,
          );
          this.freeGiftJson = json;
          this.setText(json);

          if (this.freeGiftJson.variantType === "select") {
            this.querySelector(".free-gift-select select")?.addEventListener(
              "change",
              (event) => this.onVarBtnSelect(event),
            );
          } else {
            this.querySelectorAll(".free-gift-varitant-btn").forEach((item) => {
              item.addEventListener("click", (event) =>
                this.onVarBtnClick(event),
              );
              item.addEventListener("keydown", (event) => {
                if (event.repeat) return;
                // Keyboard must respect the disabled state: mouse clicks are
                // blocked by pointer-events:none, which keydown bypasses —
                // without this guard, keyboard could add a below-threshold gift.
                if (item.classList.contains("disabled")) return;
                if (
                  event.key === "Enter" ||
                  event.key === " " ||
                  event.key === "Spacebar"
                ) {
                  event.preventDefault();
                  this.onVarBtnClick(event);
                }
              });
            });
          }

          if (this.freeGiftJson.addToType === "add-btn") {
            const addBtn = this.querySelector(".free-gift-product-buy");
            addBtn.addEventListener("click", (event) =>
              this.onAddBtnClick(event),
            );
            addBtn.addEventListener("keydown", (event) => {
              if (event.repeat) return;
              if (
                event.key === "Enter" ||
                event.key === " " ||
                event.key === "Spacebar"
              ) {
                event.preventDefault();
                this.onAddBtnClick(event);
              }
            });
          }

          this.onCartUpdate();
        }

        rate = 0;
        freeGiftJson = {};
        cartTotalPrice = 0;
        cartItems = {};
        freeProductAmount = 0;
        freeProductData = {};
        hasFreeProductInCart = false;

        setText(data) {
          const freeAmount = Number(data.freeAmount * this.rate);
          const currency = this.freeGiftJson.currency;

          if (this.querySelector("#free-product-title"))
            this.querySelector("#free-product-title").innerHTML =
              data.freeProductTitle.replace(
                "$money",
                currency + (freeAmount / 100).toFixed(2),
              );

          if (freeAmount > this.cartItems.total_price) {
            const unlockAmount =
              (freeAmount - this.cartItems.total_price) / 100;
            if (this.querySelector("#free-product-subtitle"))
              this.querySelector("#free-product-subtitle").innerHTML =
                data.freeProductSubtitle.replace(
                  "$money",
                  currency + unlockAmount.toFixed(2),
                );

            if (
              this.freeGiftJson.addToType === "add-btn" &&
              this.querySelector("#free-product-unlock")
            )
              this.querySelector("#free-product-unlock").innerHTML =
                data.freeUnlockText.replace(
                  "$money",
                  currency + unlockAmount.toFixed(2),
                );
          } else if (
            this.freeGiftJson.addToType === "add-btn" &&
            this.querySelector("#free-product-unlock")
          ) {
            this.querySelector("#free-product-unlock").innerHTML =
              data.freeBtnFullfilText;
          }
        }

        onVarBtnSelect(event) {
          if (loading) {
            return;
          }

          if (this.freeGiftJson.addToType !== "add-btn") {
            const id = event.target.value;
            loading = true;
            event.target.closest("div").classList.add("free-gift-loading");
            CartJS.addItem(id);
          }
        }
        // Handle free gift eligibility and tier progression
        onCartUpdate() {
          const index = Number(this.getAttribute("data-index"));
          let isFirstInCart = false;

          if (!this.freeProductData) return;

          // Check whether THIS gift is already in cart
          for (let i = 0; i < this.cartItems.items.length; i++) {
            const item = this.cartItems.items[i];
            for (const variant of this.freeProductData) {
              if (item.variant_id === variant.id && item.final_line_price === 0) {
                this.hasFreeProductInCart = true;
                this.freeProductIndex = i + 1;
                break;
              }
            }
          }

          const firstProduct = document.querySelectorAll("free-gift-product")[0]
          if (index === 1 && firstProduct) {
            let freeProductData = JSON.parse(firstProduct.querySelector("#free-product-variants").innerHTML)

            for (let i = 0; i < this.cartItems.items.length; i++) {
              const item = this.cartItems.items[i]
              for (const variant of freeProductData) {
                if (item.variant_id === variant.id && item.final_line_price === 0) {
                  isFirstInCart = true;
                  break
                }
              }
            }

            //when first product in cart, show the progress bar for second product
            //add based on customer feedback

            if (isFirstInCart && document.querySelectorAll(".tier-four")) {
              const tierFourElements = document.querySelectorAll(".tier-four");

              tierFourElements.forEach(function (element) {
                element.style.display = "flex";
              });
            }
          }

          // 如果购物车金额达到了free gift的金额
          if (this.cartTotalPrice >= this.freeProductAmount) {
            // 如果购物车里面没有
            if (!this.hasFreeProductInCart) {
              // 如果只有一个variants
              if (this.freeProductData.length === 1 && this.freeGiftJson.addType === "auto") {
                loading = true
                CartJS.addItem(this.freeProductData[0].id)
              } else {
                // this.style.display = "block"
                if (index === 0) {
                  this.style.display = "block"
                } else if (isFirstInCart) {
                  this.style.display = "block"
                }
                if (this.freeGiftJson.variantType !== "select") {
                  this.querySelectorAll(".free-gift-varitant-btn").forEach(item => {
                    item.classList.remove("disabled")
                    item.removeAttribute("aria-disabled")
                  })
                } else {
                  this.querySelector(".free-gift-select")?.classList.remove("disabled")
                }

                if (this.freeGiftJson.addToType == "add-btn") {
                  this.querySelector("#free-product-btn").classList.remove("disabled")
                  this.querySelector("#free-product-btn").removeAttribute("aria-disabled")
                }
              }
            } else {
              this.style.display = "none"
              // Gift is in the cart: replace the "Add to bag below." tier
              // message with a confirmation that names the gift.
              const giftName = this.querySelector(
                ".product-title",
              )?.textContent.trim();
              const fulfilText = document.querySelector(
                index === 0 ? "#tier-three-fullfil-text" : "#tier-four-fullfil-text",
              );
              if (giftName && fulfilText) {
                fulfilText.innerHTML = `Nice one. Your free ${giftName} has been added.`;
              }
            }
          } else if (this.hasFreeProductInCart && this.freeProductAmount > this.cartTotalPrice) {
            // this.style.display = "block"
            if (index === 0) {
              this.style.display = "block"
            } else if (isFirstInCart) {
              this.style.display = "block";
            }
          } else {
            // this.style.display = "block"
            if (index === 0) {
              this.style.display = "block"
            } else if (isFirstInCart) {
              this.style.display = "block"
            }
          }
        }
        
        onAddBtnClick(event) {
          if (
            event.target
              .closest("#free-product-btn")
              .classList.contains("free-gift-loading") ||
            event.target
              .closest("#free-product-btn")
              .classList.contains("disabled")
          ) {
            return;
          }

          let id = "";
          if (
            this.freeGiftJson.variantType === "select" &&
            this.querySelector("select")
          ) {
            id = this.querySelector("select").value;
          } else if (this.querySelectorAll(".free-gift-varitant-btn").length) {
            this.querySelectorAll(".free-gift-varitant-btn").forEach((item) => {
              if (item.classList.contains("selected")) {
                id = item.getAttribute("data-var-id");
              }
            });
          } else {
            id =
              this.querySelector("#free-product-btn").getAttribute(
                "data-var-id",
              );
          }

          event.target
            .closest("#free-product-btn")
            .classList.add("free-gift-loading");

          $(document).on("cart.requestComplete", this.updateCart);
          loading = true;
          if (id) {
            CartJS.addItem(id);
          } else {
            CartJS.addItem(event.target.getAttribute("data-var-id"));
          }

        }

        updateCart() {
          publish(PUB_SUB_EVENTS.cartUpdate, { isAll: true });
          $(document).off("cart.requestComplete", this.updateCart);
        }

        onVarBtnClick(event) {
    const varBtn = event.target.closest(".free-gift-varitant-btn");
    if (varBtn && varBtn.classList.contains("disabled")) return;
          if (loading) {
            return;
          }

          this.querySelectorAll(".free-gift-varitant-btn").forEach((item) => {
            item.classList.remove("selected");
          });
          this.querySelector(".free-gift-product-buy")?.classList.remove(
            "disabled",
          );
          this.querySelector(".free-gift-product-buy")?.removeAttribute(
            "aria-disabled",
          );

          event.target.classList.add("selected");

          if (this.freeGiftJson.addToType !== "add-btn") {
            loading = true;
            CartJS.addItem(event.target.getAttribute("data-var-id"));
            event.target
              .closest(".free-gift-varitant-btn")
              .classList.add("free-gift-loading");
          }
        }
      },
    );
  }

  if (!customElements.get("additional-products")) {
    customElements.define(
      "additional-products",
      class AdditionalProducts extends HTMLElement {
        constructor() {
          super();

          this.freeGiftJson = JSON.parse(
            this.querySelector("#additional-product-json").innerHTML,
          );

          if (this.freeGiftJson.variantType === "btn")
            this.querySelectorAll(".additional-variants-btn").forEach((item) =>
              item.addEventListener("click", (event) =>
                this.onVarBtnClick(event),
              ),
            );
          else {
            this.querySelectorAll(".free-gift-select select").forEach((item) =>
              item.addEventListener("change", (event) => {
                this.onVarBtnSelect(event);
              }),
            );
          }

          if (this.querySelector(".add-btn")) {
            this.querySelectorAll(".add-btn").forEach((item) =>
              item.addEventListener("click", (event) => {
                let id = "";
                if (event.target.classList.contains("add-btn")) {
                  event.target.classList.add("free-gift-loading");
                  id = event.target.getAttribute("data-var-id");
                } else {
                  event.target.parentNode.classList.add("free-gift-loading");
                  id = event.target.parentNode.getAttribute("data-var-id");
                }

                loading = true;
                CartJS.addItem(id);
              }),
            );
          }

          this.onCartUpdate();
          if (document.querySelector(".main-carousel")) {
            flkty = new Flickity(document.querySelector(".main-carousel"), {
              cellAlign: "left",
              prevNextButtons: false,
              contains: true,
              pageDots: false,
            });
            flkty.resize();
          }
        }

        cartItems = {};
        freeGiftJson = {};

        onCartUpdate() {
          this.cartItems = JSON.parse(
            this.querySelector("#additional-cart-json").innerHTML,
          );
          let count = 0;
          this.querySelectorAll(".additional-product-card").forEach((card) => {
            const id = Number(card.getAttribute("data-product-id"));
            if (
              !this.cartItems.items.find((item) => item.product_id === id) &&
              count < 3
            ) {
              card.style.display = "flex";
              count += 1;
            } else {
              card.style.display = "none";
              card.parentNode.removeChild(card);
            }
          });
          if (count === 0) {
            this.style.display = "none";
          }
        }

        onVarBtnSelect(event) {
          const id = event.target.value;
          event.target.closest("div").classList.add("free-gift-loading");
          CartJS.addItem(id);
        }

        onVarBtnClick(event) {
          if (loading) {
            return;
          }

          const id = event.target.getAttribute("data-var-id");
          // event.target.parentNode.parentNode.parentNode.parentNode.style.display = 'none'
          loading = true;
          CartJS.addItem(id);
          event.target
            .closest(".additional-variants-btn")
            .classList.add("free-gift-loading");
        }
      },
    );
  }

  if (!customElements.get("upsell-item")) {
    customElements.define(
      "upsell-item",
      class UpsellItem extends HTMLElement {
        constructor() {
          super();

          this.variantType = this.getAttribute("data-variant-type");
          this.cartItems = JSON.parse(
            this.querySelector("#cart-json").innerHTML,
          );

          if (this.variantType === "btn")
            this.querySelectorAll(".upsell-variants-btn").forEach((item) =>
              item.addEventListener("click", (event) =>
                this.onVarBtnClick(event),
              ),
            );
          else
            this.querySelector(".free-gift-select select")?.addEventListener(
              "change",
              (event) => this.onVarBtnSelect(event),
            );

          this.querySelector(".add-btn")?.addEventListener("click", (event) => {
            let id = "";
            if (event.target.classList.contains("add-btn")) {
              event.target.classList.add("free-gift-loading");
              id = event.target.getAttribute("data-var-id");
            } else {
              event.target.parentNode.classList.add("free-gift-loading");
              id = event.target.parentNode.getAttribute("data-var-id");
            }

            loading = true;
            CartJS.addItem(id);
          });

          this.querySelector(".upsell-item-close")?.addEventListener(
            "click",
            () => {
              this.style.display = "none";
            },
          );

          this.onCartUpdate();
        }

        cartItems = {};
        addToType = "";
        variantType = "";

        onCartUpdate() {
          if (
            !this.cartItems.items.find(
              (item) =>
                item.product_id ===
                Number(this.getAttribute("data-product-id")),
            ) &&
            !localStorage.getItem(
              `upsell-hide-${this.getAttribute("data-product-id")}-${this.getAttribute("data-cart-id")}`,
            )
          ) {
            this.querySelector(".product-card").style.display = "flex";
            this.style.display = "block";
          } else {
            this.style.display = "none";
            this.querySelector(".product-card").style.display = "none";
          }
        }

        onVarBtnSelect(event) {
          const id = event.target.value;
          event.target.closest("div").classList.add("free-gift-loading");
          CartJS.addItem(id);
        }

        onVarBtnClick(event) {
          if (loading) {
            return;
          }

          const id = event.target.getAttribute("data-var-id");
          loading = true;
          CartJS.addItem(id);
          event.target
            .closest(".upsell-variants-btn")
            .classList.add("free-gift-loading");
        }
      },
    );
  }

  // $(document).on('cart.requestComplete', (event, cart) => {
  //   loading = false
  // })
});
